import { http } from '@/shared/api/http'

export interface AiInitToken {
  initToken: string
  issuedAt: number
  expiresAt: number
  expiresInSeconds: number
  erpReadBaseUrl: string
  tokenType: string
}

// 로그인 JWT로 AI 연동용 HMAC 토큰 발급 (유효 30분). needAuth 기본 true라 인터셉터가 Bearer 자동 첨부.
export async function issueAiInitToken(): Promise<AiInitToken> {
  return http.post<AiInitToken>('/api/ai/init-token')
}
